<script>
  export let sizeStyle = 'heading';

  $: sizeClasses = {
    heading: 'text-3xl sm:text-7xl',
    formHeading: 'text-2xl sm:text-5xl'
  }[sizeStyle];
</script>

<h1 class="mt-4 font-extrabold tracking-tight text-slate-900 xl:max-w-[43.5rem] {sizeClasses}">
  <slot />
</h1>
